/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, TableContainer, Checkbox, TableSortLabel } from "@mui/material";
import { colors } from "../../themes/dashboard";

export const StyledModalTableContainer = styled(TableContainer)({
  mt: 1,
  boxShadow: "none",
  overflowX: "auto",
  height: "fit-content",
  "&::-webkit-scrollbar": {
    height: "var(--app-scrollbar-size)",
  },
  "&::-webkit-scrollbar-track": {
    background: "var(--app-scrollbar-track)",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "var(--app-scrollbar-thumb)",
    borderRadius: "999px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "var(--app-scrollbar-thumb-hover)",
  },
  scrollbarWidth: "thin",
  scrollbarColor: "var(--app-scrollbar-thumb) var(--app-scrollbar-track)",
})

export const StyledCheckBox = styled(Checkbox)({
  '&.Mui-checked': {
    color: '#ea590e',
  },
  color: '#E4E4E7',
  height: '17px',
  width: '17px',
  padding: 0,
})

export const StyledTableSortLabel = styled(TableSortLabel)(({ orderBy, colKey }) => ({
  "& .MuiTableSortLabel-icon": {
    opacity: orderBy === colKey ? 1 : 0.75,
    color: colors.infoColor,
    transition: "0.2s ease",
  },
}))
